// @ts-expect-error -- Suppresses TS and ESLint errors.
type _ = Types.Scalars;
import type * as Types from '@wirechunk/ui/api';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type RefreshSessionMutationVariables = Types.Exact<{ [key: string]: never }>;

export type RefreshSessionMutation = { refreshSession: boolean };

export const RefreshSessionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RefreshSession' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'refreshSession' } }],
      },
    },
  ],
} as unknown as DocumentNode<RefreshSessionMutation, RefreshSessionMutationVariables>;
